import {Button, ButtonGroup} from 'platform/components';
import {Text, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

interface CampaignPublishingContentProps {
  isCreating?: boolean;
  onSelect: (shouldRepublishAds: boolean) => void;
}

export function CampaignPublishingContent(props: CampaignPublishingContentProps) {
  const texts = props.isCreating
    ? {
        description: i18n.t('entity.salesCampaign.publishDialog.description'),
        reject: i18n.t('entity.salesCampaign.publishDialog.reject'),
        confirm: i18n.t('entity.salesCampaign.publishDialog.confirm'),
      }
    : {
        description: i18n.t('entity.salesCampaign.republishDialog.description'),
        reject: i18n.t('entity.salesCampaign.republishDialog.reject'),
        confirm: i18n.t('entity.salesCampaign.republishDialog.confirm'),
      };

  return (
    <VStack spacing={4}>
      <Text>{texts.description}</Text>
      <ButtonGroup align="right">
        <Button
          variant="secondary"
          onClick={() => props.onSelect(false)}
          title={texts.reject}
          data-testid="campaignPublishingContent-reject"
        />
        <Button
          variant="primary"
          onClick={() => props.onSelect(true)}
          title={texts.confirm}
          data-testid="campaignPublishingContent-confirm"
        />
      </ButtonGroup>
    </VStack>
  );
}
